import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    plaqueScore: 0,
    gumScore: 0
}

const plaqueScore = createSlice({
    name: "plaqueScore",
    initialState,
    reducers: {
        clearScore: () => {
            return initialState
        },

        addScore: (state, action) => {
            state.plaqueScore = action.payload.plaqueScore
            state.gumScore = action.payload.gumScore
        }
    }
})

export default plaqueScore.reducer
export const { clearScore, addScore } = plaqueScore.actions